import axios from "axios"
import { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { rateSheet } from "../../lib/tmpData"

const Membership = () => {
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        birthday: "",
        address: "",
        type: "",
        pcs: "N",
        promocode: ""
    })

    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    useEffect(() => {
        const promoFromUrl = searchParams.get("promocode")

        if (promoFromUrl) {
            setFormData(prev => ({
                ...prev,
                promocode: promoFromUrl
            }))
        }
    }, [searchParams])

    const handleSideNav = () => {
        if (document.querySelector(".main-nav").classList.contains("slidenav")) {
            document.querySelector(".main-nav").classList.remove("slidenav")
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            const response = await axios.post(
                `https://riverside-api-f5ebf4643370.herokuapp.com/email/new-member`,
                formData
            )
            navigate("/appt")
        } catch (error) {
            console.log(error)
            window.location.reload()
        }
    }

    return (
        <div onClick={handleSideNav}>

            <div className="breadcrumb">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb-wrapper">
                                <div className="breadcrumb-inner">
                                    <h1>Membership</h1>
                                    <span><a href="/">Home<i className="fas fa-angle-right"></i></a>Membership</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ display: "flex", justifyContent: "center", marginTop: "2em", marginBottom: "2em" }}>
                <div className="col-md-7 col-xl-6" style={{ display: "flex", justifyContent: "center" }}>
                    <div className="contact-form">
                        <h3>Join Riverside</h3>
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6">
                                    <input
                                        required
                                        type="text"
                                        name="first_name"
                                        placeholder="First Name"
                                        value={formData.first_name}
                                        onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <input
                                        required
                                        type="text"
                                        name="last_name"
                                        placeholder="Last Name"
                                        value={formData.last_name}
                                        onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <input
                                        required
                                        type="email"
                                        name="email"
                                        placeholder="Your Email"
                                        value={formData.email}
                                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <input
                                        required
                                        type="text"
                                        name="phone"
                                        placeholder="Phone #"
                                        value={formData.phone}
                                        onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <select
                                        required
                                        className="dropdown"
                                        onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                                        value={formData.type}
                                    >
                                        <option value="" disabled>Select Membership Type</option>
                                        <option value="Single">Single</option>
                                        <option value="Couple">Couple</option>
                                        <option value="Family">Family</option>
                                        <option value="Associate">Associate</option>
                                        <option value="Junior">Junior</option>
                                        <option value="Social">Social</option>
                                        <option value="Corporate">Corporate</option>
                                    </select>
                                </div>

                                <div className="col-md-6">
                                    <div className="btn-group" role="group" aria-label="Cart Storage">
                                        <span id="pcs">Personal Cart Storage</span>

                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="btnradio"
                                            id="btnradioY"
                                            autoComplete="off"
                                            checked={formData.pcs === "Y"}
                                            onChange={() => setFormData({ ...formData, pcs: "Y" })}
                                        />
                                        <label className="btn btn-outline-primary" htmlFor="btnradioY">Yes</label>

                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="btnradio"
                                            id="btnradioN"
                                            autoComplete="off"
                                            checked={formData.pcs === "N"}
                                            onChange={() => setFormData({ ...formData, pcs: "N" })}
                                        />
                                        <label className="btn btn-outline-primary" htmlFor="btnradioN">No</label>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        name="promocode"
                                        placeholder="Promo Code"
                                        value={formData.promocode}
                                        onChange={(e) => setFormData({ ...formData, promocode: e.target.value })}
                                        readOnly
                                        style={{
                                            color: formData.promocode ? "#2e7d32" : "inherit",
                                            fontWeight: formData.promocode ? "700" : "normal",
                                            border: formData.promocode ? "2px solid #2e7d32" : "",
                                            backgroundColor: formData.promocode ? "#f1f8f4" : ""
                                        }}                                        
                                    />
                                </div>
                            </div>

                            <label htmlFor="birthday">Birthday</label>
                            <input
                                required
                                type="date"
                                name="birthday"
                                value={formData.birthday}
                                onChange={(e) => setFormData({ ...formData, birthday: e.target.value })}
                            />

                            <input
                                required
                                type="text"
                                name="address"
                                placeholder="Home Address"
                                value={formData.address}
                                onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                            />

                            <div className="button--wrap">
                                <button type="submit" className="eg-btn btn--primary golf-btn mx-auto">
                                    Join<i className="bi bi-arrow-right"></i>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="tab-content" id="pills-tabContent" style={{ padding: "2em" }}>
                <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                    <div className="row g-4">
                        {rateSheet.map(rate => (
                            <div key={rate.service} className="col-md-6 col-lg-4">
                                <div className="price-box" style={{ minHeight: "550px" }}>
                                    <h3>{rate.service}</h3>
                                    <h2>${rate.price}<sub>/Per Year</sub></h2>

                                    {rate?.dependent ? (
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <h2 style={{ fontSize: "18px", marginRight: "0.5em", marginTop: "0px", marginBottom: "20px" }}>
                                                Dependents:
                                            </h2>
                                            <h2 style={{ fontSize: "18px", marginTop: "0px", marginBottom: "20px" }}>
                                                ${rate.dependent}
                                            </h2>
                                        </div>
                                    ) : null}

                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <h2 style={{ fontSize: "16px", margin: 0, width: "75%" }}>{rate.info}</h2>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Membership